import "react-native-reanimated";

import { WidgetPos } from "../types";
import { getPositionOrdinal } from "./getPositionOrdinal";
import { getPositionsBetween } from "./getPositionsBetween";
import { validPositions } from "./validPositions";

export function moveItem<T extends WidgetPos>(
  fromId: string,
  toTarget: T,
  positions: T[],
  numberOfColumns: number = 4,
  numberOfRows: number = 4
): { widgets: T[]; success: boolean } {
  "worklet";
  const naivePositioning = positions.map((p) =>
    p.id === fromId ? toTarget : p
  );

  if (validPositions(naivePositioning, numberOfColumns, numberOfRows)) {
    return { widgets: naivePositioning, success: true };
  }

  const fromPosition = positions.find((p) => p.id === fromId);
  if (!fromPosition) {
    throw new Error("move item fromPosition not found");
  }
  const moveDirection = {
    up: getPositionOrdinal(fromPosition) > getPositionOrdinal(toTarget),
    down: getPositionOrdinal(fromPosition) < getPositionOrdinal(toTarget),
  };

  const positionsBetween = getPositionsBetween(fromId, toTarget, positions);

  if (
    toTarget.w === 1 &&
    positionsBetween.findIndex(({ w }) => w !== 1) === -1
  ) {
    return {
      widgets: naivePositioning.map((position) => {
        if (position.id === fromId) {
          return toTarget;
        }
        if (positionsBetween.findIndex(({ id }) => id === position.id) > -1) {
          const x = (position.x + toTarget.w) % 2;

          if (moveDirection.up) {
            const vertical = position.y + (x === 0 ? 1 : 0);
            const y = vertical % 4;
            const c = position.c + (vertical > 3 ? 1 : 0);
            return { ...position, x, y, c };
          }

          if (moveDirection.down) {
            const vertical = position.y - (x === 1 ? 1 : 0);
            const y = vertical < 0 ? 4 + vertical : vertical;
            const c = position.c - (vertical < 0 ? 1 : 0);
            return { ...position, x, y, c };
          }
        }
        return position;
      }),
      success: true,
    };
  }

  const newPositions = positions.map((position) => {
    if (position.id === fromId) {
      return toTarget;
    }

    if (
      fromPosition.c === position.c &&
      fromPosition.y === position.y &&
      toTarget.h === 1 &&
      toTarget.w === 1 &&
      position.h === 1 &&
      position.w === 1
    ) {
      return { ...position, c: toTarget.c, y: toTarget.y };
    }

    if (positionsBetween.findIndex(({ id }) => id === position.id) > -1) {
      if (moveDirection.up) {
        const vertical = position.y + toTarget.h;
        const y = vertical % 4;
        const c = position.c + (vertical > 3 ? 1 : 0);
        return {
          ...position,
          y,
          c,
        };
      }
      if (moveDirection.down) {
        const vertical = position.y - toTarget.h;
        const y = vertical < 0 ? 4 + vertical : vertical;
        const c = position.c - (vertical < 0 ? 1 : 0);
        return {
          ...position,
          y,
          c,
        };
      }
    }

    return position;
  });

  if (validPositions(newPositions, numberOfColumns, numberOfRows)) {
    return { widgets: newPositions, success: true };
  }

  return { widgets: positions, success: false };
}
